import * as Yup from 'yup';
import { inRange } from 'lodash';
import { InvoiceCommissionValueType } from '../../types';
import { CommissionType } from '../../../domain/types';

export const invoiceCommissionFormValidationSchema = Yup.object({
  agentId: Yup.number().required('Il campo è obbligatorio'),
  type: Yup.string().oneOf(Object.values(CommissionType), "Il valore deve essere uno dei seguenti valori: 'STANDARD', 'OVER' o 'REFERRAL'").required('Il campo è obbligatorio'),
  valueType: Yup.string().oneOf(Object.values(InvoiceCommissionValueType), "Il valore deve essere uno dei seguenti valori: 'FIXED' o 'PERCENTAGE'").required('Il campo è obbligatorio'),
  value: Yup.string().matches(/^\d*\.?\d*$/, 'Valore invalido').test('isValid', 'Valore invalido', (value, ctx) => {
    const { valueType } = ctx.parent;

    if (!value) return true;

    const numericValue = value ? parseFloat(value) : -1;

    if (valueType === InvoiceCommissionValueType.FIXED && numericValue < 1) {
      return ctx.createError({
        path: 'value',
        message: 'Il valore minimo è 1€',
      });
    }

    if (valueType === InvoiceCommissionValueType.PERCENTAGE && !inRange(numericValue, 0.01, 100.01)) {
      return ctx.createError({
        path: 'value',
        message: 'Il valore deve essere compreso tra 0 e 100%',
      });
    }

    return true;
  }).required('Il campo è obbligatorio'),
});
